import { render, staticRenderFns } from "./modelSalesTable.vue?vue&type=template&id=2e4353ab&scoped=true&"
import script from "./modelSalesTable.vue?vue&type=script&lang=js&"
export * from "./modelSalesTable.vue?vue&type=script&lang=js&"
import style0 from "./modelSalesTable.vue?vue&type=style&index=0&id=2e4353ab&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4353ab",
  null
  
)

export default component.exports